import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { useContext } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { useForm } from "react-hook-form";
import TurnosConvencionesContext from "../../store/modal-convenciones-context";
import { generarCuadroTurnos } from "../../services/nomina-cuadro-turnos";
import DateRangePicker from "../../../../core/ui/components/DateRangePicker";
import { validarRangoDeFecha } from "../../helpers/cuadro-turnos-helper";
import moment from "moment";
import { useState } from "react";

const FormGenerarCuadroTurno = ({
    modal,
    onGenerarCuadroTurnos,
    sedeAreaLider,
}) => {
    const { refrescarConvenciones } = useContext(TurnosConvencionesContext);
    const [rangoFecha, setRangoFecha] = useState({
        fechaInicio: moment().startOf('month').format('YYYY-MM-DD'),
        fechaFin: moment().endOf('month').format('YYYY-MM-DD'),
    });

    const defaultValues = {
        fechaCuadroTurnoFin: "",
        fechaCuadroTurnoInicio: "",
    };

    const form = useForm({ defaultValues });

    const onSubmit = async (data) => {
        data.fechaCuadroTurnoInicio = rangoFecha.fechaInicio;
        data.fechaCuadroTurnoFin = rangoFecha.fechaFin;
        sedeAreaLider && (data.idSedeArea = sedeAreaLider);
        const response = await generarCuadroTurnos(data);

        response.status
            ? toast.success(response.message)
            : toast.error(response.message);

        response.status && onGenerarCuadroTurnos();
        refrescarConvenciones();
    };

    const onChangeDateRange = function (inicio, fin) {
        const fechaInicio = inicio.format("YYYY-MM-DD");
        const fechaFin = fin.format("YYYY-MM-DD");
        const diasMaximos = 31;
        const esRangoValido = validarRangoDeFecha(fechaInicio, fechaFin, diasMaximos);

        if (!esRangoValido) {
            return toast.error(
                `El rango de fecha no puede ser mayor a ${diasMaximos} días`
            );
        }

        setRangoFecha({ fechaInicio, fechaFin });
    };

    return (
        <FormModal
            size="lg"
            form={form}
            isOpen={modal.show}
            onSubmit={onSubmit}
            id="formCrearCuadroTurnoAutomatico"
            headerTitle="Crear cuadro de turno automatico"
            closeModal={() => modal.close()}
        >
            <Row>
                <Col sm={12}>
                    <DateRangePicker
                        id="cuadroTurnoAutomaticoFecha"
                        startDate={rangoFecha.fechaInicio}
                        endDate={rangoFecha.fechaFin}
                        onChangeRange={onChangeDateRange}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormGenerarCuadroTurno.propTypes = {
    modal: PropTypes.object,
    onGenerarCuadroTurnos: PropTypes.func,
    sedeAreaLider: PropTypes.string,
};

export default FormGenerarCuadroTurno;
